export const TRANSPORTER_BANNER_KEY = 'active_transporter_banner_viewed';
export const SAFETY_BANNER_KEY = 'safety_banner_viewed';
export const ETRN_BANNER_KEY = 'etrn_banner_viewed';
export const AVG_PRICE_BANNER_KEY = 'avg_price_banner_viewed';
export const LAST_SHOWED_BANNER_ID = 'last_showed_banner_id';
